import { render, staticRenderFns } from "./addInvhist.vue?vue&type=template&id=545e31ad&scoped=true&"
import script from "./addInvhist.vue?vue&type=script&lang=js&"
export * from "./addInvhist.vue?vue&type=script&lang=js&"
import style0 from "./addInvhist.vue?vue&type=style&index=0&id=545e31ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e31ad",
  null
  
)

export default component.exports